export abstract class DeviceRepository {
  abstract add(fcmToken: string, deviceUuid: string): Promise<void>;

  abstract remove(fcmToken: string, deviceUuid: string): Promise<void>;
}
